<template>
  <v-container
    fluid
    cols="12"
    class="d-flex"
  >
    <v-layout
      row
      wrap
    >
      <v-flex xs6>
        <!-- Document Data Address DETAILS START -->
        <v-card
          v-if="item.document_data && item.document_data.address"
          class="ma-2"
        >
          <v-card-title class="toolbar success white--text subheading">
            <span>Document Data Address</span>
          </v-card-title>

          <v-card-text>
            <v-layout
              wrap
              class="pa-0"
            >
              <v-flex
                v-for="field in cleanFields(item.document_data.address)"
                :key="field"
                class="pa-2"
                xs6
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span>
                      <v-text-field
                        :label="field"
                        :value="item.document_data.address[field]"
                        readonly
                        class="body-1"
                        :class="field"
                      />
                    </span>
                  </template>
                  <span>
                    field: {{ field }}
                  </span>
                </v-tooltip>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        <!-- Document Data Address  DETAILS END -->
      </v-flex>
      <v-flex
        xs12
      >
        <v-btn
          dark
          flat
          block
          color="primary"
          @click.stop="() => setDebugDocument(item)"
        >
          <v-icon
            class="pr-2"
          >
            adb
          </v-icon>
          Debug
        </v-btn>
      </v-flex>
    </v-layout>
    <DebugDialog
      :visible="isDebugDialogActive"
      :debug-object="debugObject"
      :title="debugTitle"
      @close="isDebugDialogActive = false"
    />
  </v-container>
</template>

<script>

import DebugDialog from '@/components/payoutsAndTaxes/payout/dialogs/shared/DebugDialog';

export default {
  name: 'JeaUserDetails',
  components: {
    DebugDialog,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rowsPerPageItems: [4, 8, 12],
      searchQuery: '',
      debugObject: {},
      debugTitle: '',
      isDebugDialogActive: false,
      pagination: {
        rowsPerPage: 4,
      },
    };
  },
  methods: {
    cleanFields(data) {
      return Object.keys(data).filter(field => !!data[field] && typeof data[field] !== 'object');
    },
    setDebugDocument(document) {
      this.debugObject = document;
      this.debugTitle = 'Debug Payload';
      this.isDebugDialogActive = true;
    },
  },
};
</script>
<style lang="scss" >
.v-data-iterator .v-list__tile{
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/shared/JeaUserDetails.vue